import '../createContextUtilities/849fab54d7a821eeafd2c4e0244d34d6a384b57f34cbf0617e0253b2c4ade8b3.cfe-internal.js';
import createContextUtilities from '../createContextUtilities/75e5580757e6f68807f92e07850cfc0605a5ff6677179fbc573cffe4ac0a5df9.cfe-internal.js';

var _createContextUtiliti = createContextUtilities({
    isParentAnchorHidden: false
  }),
  PopperContextProvider = _createContextUtiliti.Provider,
  usePopperContext = _createContextUtiliti.useContext;

export { PopperContextProvider, usePopperContext as default };
